import request from "./request"

export const login = data => request.post("/auth/login", data)
export const profileGet = () => request.get("/auth/profile_get")
export const passwordUpdate = data => request.post("/auth/password_update", data)
export const logout = () => request.post("/auth/logout")
export const overviewGet = () => request.get("/dashboard/overview_get")
export const memberListGet = params => request.get("/member/list_get", { params })
export const creatorSearchGet = params => request.get("/member/search_get", { params })
export const userCreate = data => request.post("/member/user_create", data)
export const inviteAdd = data => request.post("/member/invite_add", data)
export const requestListGet = params => request.get("/member/request_list_get", { params })
export const requestReview = data => request.post("/member/request_review", data)
export const memberShareUpdate = data => request.post("/member/share_update", data)
export const analyticsSummaryGet = params => request.get("/analytics/summary_get", { params })
export const incomeListGet = params => request.get("/analytics/income_list_get", { params })
export const settlementListGet = params => request.get("/finance/settlement_list_get", { params })
export const withdrawalListGet = params => request.get("/finance/withdrawal_list_get", { params })
export const withdrawalAdd = data => request.post("/finance/withdrawal_add", data)
export const messageListGet = params => request.get("/message/list_get", { params })
export const messageReadUpdate = data => request.post("/message/read_update", data)
export const messageSend = data => request.post("/message/send", data)
